<template>
  <div>
    <header-section :title='"Quản lý lịch hẹn"'></header-section>
    <div id="appointment-component" class="container">
      <div class="nav-wrapper">
        <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
          <li class="nav-item">
              <div @click="set_component('counselor_appointment')" class="nav-link mb-sm-6 mb-md-0" role="tab" aria-controls="tabs-icons-text-1"
              :class = "{active: current_state=='counselor_appointment'}"></i>Lịch hẹn với Cố vấn</div>
          </li>
          <li class="nav-item">
              <div @click="set_component('customer_appointment')" class="nav-link mb-sm-6 mb-md-0" role="tab" aria-controls="tabs-icons-text-1" :class = "{active: current_state=='customer_appointment'}"></i>Lịch hẹn với Khách hàng</div>
          </li>
        </ul>
      </div>      
      <list-appointment-counselor v-if="current_state == 'counselor_appointment'"></list-appointment-counselor> 
      <list-appointment-customer v-if="current_state == 'customer_appointment'"></list-appointment-customer>
    </div>
  </div>
</template>
<script>  
  import HeaderSection from "./components/Common/HeaderSection.vue";
  import ListAppointmentCounselor from "./components/MyAppointment/ListAppointmentCounselor.vue";
  import ListAppointmentCustomer from "./components/MyAppointment/ListAppointmentCustomer.vue";
  export default{
    components:{
      ListAppointmentCounselor,
      ListAppointmentCustomer,
      HeaderSection,
    },
    data: function(){
      return {
        current_state: 'counselor_appointment'
      }
    },
    methods: {
      set_component: function(state){
        this.current_state = state
      }
    },
    created: function(){
      this.$store.dispatch('vuex_appointment/get_counselor_appointment', 1)
      this.$store.dispatch('vuex_appointment/get_customer_appointment', 1)
    },
  };
</script>
<style type="scss" scoped>
  #appointment-component  {
    margin-top: 100px;
    .nav-link.mb-sm-3.mb-md-0{
      cursor: pointer;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/MyAppointment.vue